import React, { useImperativeHandle } from "react";
import { FaCircle, FaSquare } from "react-icons/fa";
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';

const CxIcon = props => {
  const { 
    backIcon, 
    backSize, 
    backColor, 
    backMargin,
    frontIcon, 
    frontSize,
    frontColor, 
    frontShell,
    frontShellColor,
    frontPos,
    disableHover
  } = props;

  const [backIconSize, ] = React.useState(backSize||'24px');
  const [boHover, setBoHover] = React.useState(false);

  const defaultBackColor = 'var(--ibs_color_cy_blue)';
  const defaultFrontColor = 'var(--ibs_color_red)';
  const hoverColor = 'var(--ibs_color_red)';

  React.useEffect(() => {
    // eslint-disable-next-line
    // Creado por Asistente de Programación el 2024-05-22
  }, []);

  useImperativeHandle(props.xref, () => {
    return {
      getType,
    };
  });

  const getType = () => { 
    return 'CxIcon' 
  };

  return (
    <div 
      style={{ 
        position: "relative", 
        width: backIconSize, 
        height: backIconSize,
        margin: backMargin||'0',
        display: 'inline-block',
        lineHeight: '0',
        cursor: 'pointer'
      }}
      onMouseEnter={() => setBoHover(true)}
      onMouseLeave={() => setBoHover(false)}
    >
      {/* Ícono de Fondo (Back) */}
      {React.cloneElement(backIcon, {
        style: { 
          position: "absolute",
          top: "0",
          left: "0",
          fontSize: backIconSize, 
          color: (boHover && !disableHover) ? hoverColor : (backColor || defaultBackColor)
        }
      })}

      {/* Ícono Frontal (Front) con Shell de seguridad */}
      {frontIcon && (
        <div style={{ 
          position: "absolute", 
          top: frontPos?.top !== undefined ? frontPos.top : 'auto',
          bottom: frontPos?.bottom !== undefined ? frontPos.bottom : (frontPos?.top === undefined ? '0' : 'auto'), 
          left: frontPos?.left !== undefined ? frontPos.left : 'auto',
          right: frontPos?.right !== undefined ? frontPos.right : (frontPos?.left === undefined ? '0' : 'auto'),
          width: frontSize||'16px',
          height: frontSize||'16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1
        }}>
          {/* Shell para evitar transparencia */}
          {frontShell === 'circle' && (
            <FaCircle style={{ 
              position: 'absolute', 
              fontSize: frontSize||'16px', 
              color: frontShellColor||'white' 
            }} />
          )}
          {frontShell === 'square' && (
            <FaSquare style={{ 
              position: 'absolute', 
              fontSize: frontSize||'16px', 
              color: frontShellColor||'white' 
            }} />
          )}
          
          {/* Icono real */}
          {React.cloneElement(frontIcon, { 
            style: { 
              position: "relative",
              fontSize: frontSize||'16px', 
              color: (boHover && !disableHover) ? hoverColor : (frontColor || defaultFrontColor),
              display: 'block'
            }
          })}
        </div>
      )}
    </div>
  );
};

export default CxIcon;